import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Accordion, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ModalLogin from "../Components/ModalLogin";
import AddSwatch from "../Functions/AddSwatch";
import authHeader from "../Services/auth-header";
import { CartUpdatedTrue } from "../Actions/types";
import {
  imgUrl,
  baseURLGetSwatchs,
  baseURLDeleteBasketProject,
} from "../config/api";

const RequestFabricSwatches = ({ products = {} }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const [showModal, setShowModal] = React.useState(false);
  const firstRender = useRef(true);
  const [bagUpdate, setBagUpdate] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [buttonStates, setButtonStates] = useState(Array(Object.keys(products).length).fill(false));
  const [bag, setBag] = useState({});
  const [cartCount, setCartCount] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [modals, setModals] = useState({});
  const [isSwatchBag, setIsSwatchBag] = useState([]);
  const [swatchLogin, setSwatchLogin] = useState(false);
  const isDisabled = selectedProducts.length === 0;
  const [refreshModal, setRefreshModal] = useState(false);

  const getFirstDesignCode = () => {
    const productArray = Object.values(products).flat();
    return productArray.length > 0 ? productArray[0].DesignCode : null;
  };

  function getCart() {
    const designCode = getFirstDesignCode();
    if (isLoggedIn) {
      const url = `${baseURLGetSwatchs}?designCode=${designCode}`;
      setRefreshModal(true);
      axios
        .get(url, {
          headers: authHeader(),
        })
        .then((response) => {
          setIsSwatchBag(response.data ? response.data : []);
        })
        .catch((err) => {
          console.log(err);
          // if (err.response && err.response.status === 401) {
          //   refreshToken().then((response2) => {
          //     if (response2 !== false) {
          //       getCart();
          //     } else {
          //       setFirstFetch(false);
          //     }
          //   });
          // } else {
          //   setFirstFetch(false);
          // }
        })
        .finally(() => {
          setTimeout(() => setRefreshModal(false), 100);
        });
    }
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  const handleButtonClick = (index, product) => {
    setButtonStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index];
      return newStates;
    });

    if (buttonStates[index]) {
      setSelectedProducts((prevProducts) =>
        prevProducts.filter((p) => p.ProductId !== product.ProductId)
      );
    } else {
      setSelectedProducts((prevProducts) => [...prevProducts, product]);
    }
  };

  function handleRemoveBag(CartDetailId) {
    axios
      .post(
        baseURLDeleteBasketProject + "/" + CartDetailId,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        console.log(`response`, response);
        if (response.status === 200) {
          setRefreshModal(true);
        }
        // setCart(response.data ? response.data : {});
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTimeout(() => setRefreshModal(false), 100);
      });
  }

  const handleRemoveProduct = (productId) => {
    setSelectedProducts((prevProducts) => {
      const updatedProducts = prevProducts.filter((p) => p.ProductId !== productId);

      setButtonStates((prevStates) =>
        prevStates.map((state, index) =>
          updatedProducts.some(
            (p) => p.ProductId === products[Object.keys(products)[index]][0].ProductId
          )
            ? state
            : false
        )
      );

      return updatedProducts;
    });
  };

  const handleRequestClick = () => {
    if (!isLoggedIn) {
      setModals((prevModals) => ({
        ...prevModals,
        side_login_modal: true,
      }));
      setSwatchLogin(true);
    } else {
      // setSwatchLogin(true);
      setShowModal(true);
      // saveProduct(product, isCompleted, false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      console.log("163");

      getCart();
      modalHandleClose("side_login_modal");
      if (swatchLogin) {
        setShowModal(true);
        setSwatchLogin(false);
      }
    }
  }, [isLoggedIn, swatchLogin]);

  const handleAddToSwatch = async () => {
    setShowModal(false);
    if (selectedProducts.length === 0) {
      //   setShowAlert(true);
    } else {
      let updatedCart = {};
      for (const product of selectedProducts) {
        try {
          const response = await AddSwatch(product.ProductId);
          updatedCart = response.data ? response.data : updatedCart;
          setBag(updatedCart);
          setSelectedProducts([]);
          setRefreshModal(true);
        } catch (error) {
          console.log(`Failed to add product ${product.ProductId} to cart`, error);
        }
      }
    }
  };

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (bagUpdate) {
        setBagUpdate(false);
      } else {
        dispatch({
          type: CartUpdatedTrue,
          payload: { mainCart: bag },
        });
      }
      if (isLoggedIn) {
        setCartCount(bag["CartDetails"]?.length || 0);
      } else {
        setCartCount(bag["drapery"]?.length || 0);
      }
    }
  }, [bag]);

  useEffect(() => {
    if (isLoggedIn && refreshModal) {
      console.log("224");

      getCart();
    }
  }, [refreshModal]);

  return (
    <>
      <div>
        <div className="request-fabric-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="#49443e"
            viewBox="0 0 512 512"
          >
            <path d="M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z" />
          </svg>
          <div style={{ position: "relative" }}>
            <p className="request-massage" onClick={handleRequestClick}>
              {t("Request fabric swatches")}
            </p>
            <p className="request-massage-hover">{t("Up to 10 Free Swatches per member")}</p>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`changeFabrics cart_modal_container cart_agree_container_swatch cart_agree_container select_swatch_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={showModal}
        onHide={() => setShowModal(false)}
        id="cart_modal"
      >
        <Modal.Header closeButton>
          <div className="selection_assistant_swatches">
            <h1 className="selection_assistant_title-swatches">{t("REQUEST SWATCHES")}</h1>
            <p className="text-swatches">{t("Select up to 10 complimentary swatches")}</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="modal_step_container">
            <Accordion flush activeKey={"1"}>
              <Card>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <div className="card_body card-body-fabric card-body-swatches">
                      <div className="fabrics_list_container_box">
                        <div className="material_detail font_en">
                          {isSwatchBag?.map((product, index) => (
                            <div className="radio_group font_en" key={index}>
                              <label className="radio_container font_en">
                                <input className="radio" type="radio" />
                                <div className="frame_img">
                                  <img
                                    className="img-fluid"
                                    src={imgUrl(product.PhotoUrl)}
                                    alt={product.ProductEnName}
                                  />
                                </div>
                              </label>
                              <div className="fabric_name_container font_en">
                                <h1>
                                  {pageLanguage === "en"
                                    ? product.ProductEnName
                                    : product.ProductName}
                                </h1>
                              </div>

                              {product.CartDetailId === null ? (
                                <button
                                  style={{ fontSize: "11px" }}
                                  className="swatchButton font_en"
                                  onClick={() => handleButtonClick(index, product)}
                                >
                                  {/* {buttonStates[index] ? t("Remove Swatch") : t("Add Swatch")} */}
                                  {selectedProducts.some((p) => p.ProductId === product.ProductId)
                                    ? t("Remove Swatch")
                                    : t("Add Swatch")}
                                </button>
                              ) : (
                                <button
                                  style={{
                                    fontSize: "11px",
                                    backgroundColor: "#49443e",
                                    color: "white",
                                  }}
                                  className="swatchButton font_en"
                                  onClick={() => handleRemoveBag(product.CartDetailId)}
                                >
                                  {t("SWATCH IN BAG")}
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              backgroundColor: selectedProducts.length > 0 ? "#f3f1ee" : "transparent",
            }}
          >
            {selectedProducts.length > 0 && (
              <div className="go_to_checkout_swatches slide-up">
                <h1 className="selection_title-swatches">{t("Selected Swatches")}</h1>
                <div className="item_swatches">
                  {selectedProducts.map((product, index) => {
                    return (
                      <div key={index} className="swatch-container">
                        <img
                          src={imgUrl(product.PhotoUrl)}
                          alt={product.ColorEnName}
                          style={{ width: "4rem", height: "4rem" }}
                        />
                        <button onClick={() => handleRemoveProduct(product.ProductId)}>
                          &times;
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="modal-footer">
              <div className="go_to_checkout">
                <div className="checkout_button_section small_checkout_button_section">
                  <button
                    className="basket_checkout btn"
                    style={{
                      width: "91%",
                      color: isDisabled ? "#d3d3d3" : "#fff",
                      backgroundColor: isDisabled ? "#f0f0f0" : "",
                      cursor: isDisabled ? "unset" : "pointer",
                    }}
                    onClick={handleAddToSwatch}
                    disabled={isDisabled}
                  >
                    {t("ADD TO BAG")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal side_login_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["side_login_modal"] === undefined ? false : modals["side_login_modal"]}
        onHide={() => {
          modalHandleClose("side_login_modal");
          setSwatchLogin(false);
        }}
        id="side_login_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalLogin text={t("fabric_login_text")} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RequestFabricSwatches;
